document.addEventListener("DOMContentLoaded", () => {
  const blocks = document.querySelectorAll("[data-animate-button]");
  blocks.forEach((block) => {
    const inner = block.querySelector(".button__inner");
    const text = inner.querySelector("p");
    if (!inner || !text) return;
    // data-hover attribute as the same as text content
    text.setAttribute("data-hover", text.textContent);
  });
});
